import { combineReducers } from 'redux-immutable'
import { connectRouter } from 'connected-react-router/immutable'

import searchDeprecated from 'reducers/deprecated/search'
import search from 'reducers/search'
import referenceParameter from 'reducers/referenceParameter'
import supportParameter from 'reducers/supportParameter'
import truck from 'reducers/truck'
import application from 'reducers/application'
import user from 'reducers/user'
import ctp from 'reducers/ctp'
import apiLookUpValues from 'reducers/apiLookUpValues'
import feature from 'reducers/feature'
import fleet from 'reducers/fleet'
import ecp from 'reducers/ecp'
import pto from 'reducers/powerTakeOff'
import addReferenceParametersWorkflow from './addReferenceParametersWorkflow'
import ctpMappingWorkflow from './ctpMappingWorkflow'
import validation from './validation'
import drawer from './drawer'
import navigator from './navigator'
import history from '../history'
import dash from './dash'
import dashBuilder from './dashBuilder'
import releaseNotes from './releaseNotes'
import dataTranslator from './dataTranslator'
import collection from './collection'
import lineNoteReader from './lineNoteReader'
import vehicleSnapshots from './vehicleSnapshots'
import fastFeature from './fastFeature'
import rulesUtils from './rulesUtils'

export const indexReducer = {
  releaseNotes,
  dash,
  dashBuilder,
  application,
  truck,
  search,
  searchDeprecated,
  referenceParameter,
  supportParameter,
  user,
  ctp,
  apiLookUpValues,
  fleet,
  feature,
  ecp,
  addReferenceParametersWorkflow,
  ctpMappingWorkflow,
  validation,
  drawer,
  navigator,
  pto,
  dataTranslator,
  collection,
  lineNoteReader,
  vehicleSnapshots,
  fastFeature,
  rulesUtils,
}

export default combineReducers({
  router: connectRouter(history),
  ...indexReducer,
})
